export default __webpack_public_path__ + "static/media/heavycloud.cf78abbf.svg";